import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchVodPrices, deleteVodPrice } from 'store/actions';

// Import translation
import { useTranslation } from 'react-i18next';

// Import columns
import { createColumns } from 'components/helpers/columns/prices';

// Import components
import { TableTemplate } from 'components/common/templates';

const VodPrices = ({
	error,
	fetchVodPrices,
	deleteVodPrice,
	resources,
	match: {
		params: { id }
	}
}) => {
	const { t } = useTranslation();

	return (
		// Dispatch fetchVodPrices, deleteVodPrice action in vod_prices
		<TableTemplate
			itemId={id}
			error={error}
			type={`vod/${id}/price`}
			typeText="prices"
			addLinkText={t('prices:buttons.add')}
			resources={resources}
			columns={createColumns}
			fetchResourcesAction={fetchVodPrices}
			deleteItemAction={deleteVodPrice}
			notificationDeleteSuccessTxt={t('prices:notification.delete_success')}
			notificationDeleteErrorTxt={t('prices:notification.delete_error')}
		></TableTemplate>
	);
};

VodPrices.propTypes = {
	error: PropTypes.bool.isRequired,
	resources: PropTypes.object.isRequired,
	fetchVodPrices: PropTypes.func.isRequired,
	deleteVodPrice: PropTypes.func.isRequired,
	match: PropTypes.shape({
		params: PropTypes.shape({ id: PropTypes.string.isRequired })
	})
};

const mapStateToProps = ({ vod: { prices } }) => ({
	error: prices.error,
	resources: prices
});

export default compose(
	connect(mapStateToProps, { fetchVodPrices, deleteVodPrice }),
	withRouter
)(VodPrices);
